// src/components/TextInputModal.tsx
import React, { useState, useEffect } from "react";
import { FiX, FiSave } from "react-icons/fi";
import "../TextInputModal.css";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (value: string) => void;
  title: string;
  placeholder?: string;
  initialValue?: string;
  confirmText?: string;
}

export default function TextInputModal({
  isOpen,
  onClose,
  onSave,
  title,
  placeholder = "",
  initialValue = "",
  confirmText = "Guardar"
}: Props) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (isOpen) {
      setValue(initialValue);
    }
  }, [isOpen, initialValue]);

  const handleSave = () => {
    const trimmedValue = value.trim();
    if (trimmedValue) {
      onSave(trimmedValue);
      onClose();
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSave();
    }
    if (e.key === 'Escape') {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="text-input-modal-overlay" onClick={onClose}>
      <div className="text-input-modal" onClick={e => e.stopPropagation()}>
        <div className="text-input-modal-header">
          <h3>{title}</h3>
          <button className="close-btn" onClick={onClose}>
            <FiX size={18} />
          </button>
        </div>
        
        <div className="text-input-modal-content">
          <input
            type="text"
            className="text-input"
            placeholder={placeholder}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={handleKeyPress}
            autoFocus
          />
        </div>
        
        <div className="text-input-modal-actions">
          <button 
            className="btn secondary"
            onClick={onClose}
          >
            Cancelar
          </button>
          <button 
            className="btn primary"
            onClick={handleSave}
            disabled={!value.trim()}
          >
            <FiSave size={16} />
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}